// this is for duplicate contact item config
export class DuplicatedContactItemConfig {
    contactName: string;
    contactId: string;
    contactInfo: Array<any>;
    instanceId: '';
    controlId: '';
}

export enum DuplicatedContactItemConfigField {
    JobTitle = 'Job Title',
    Company = 'Company',
    PrimaryEmail = 'Primary Email',
    Phone = 'Phone',
}
